import emptySearchImage from "../../assets/images/search.svg";
import "./NoSearchResult.scss";

interface NoSearchResultProps {
  searchValue: string;
  header?: string;
  message?: string;
}

const NoSearchResult = ({
  searchValue,
  header,
  message,
}: NoSearchResultProps) => {
  const defaultHeader = `No search result for “${searchValue}”`;
  const defaultMessage =
    "Did not find any results? We recommend refining your search criteria. Consider using alternative keywords or phrases to enhance your search results.";

  return (
    <div className="no-search-section">
      <img src={emptySearchImage} alt="No search results" />
      <div className="motif-body1-default-regular no-search-header">
        {header ?? defaultHeader}
      </div>
      <div className="motif-body2-default-light no-search-sub-header">
        {message ?? defaultMessage}
      </div>
    </div>
  );
};

export default NoSearchResult;
